import Axios from 'axios';
import Vue from 'vue';
import LocalConfig from '../common/js/getConfig';
import i18n from '../lang/lang'

let vue = new Vue;

let base = LocalConfig.apiURL + 'api/';

let axios = Axios.create({
  baseURL: base
});

axios.interceptors.request.use(
  config => {
    let user = localStorage.getItem('user');
    user = JSON.parse(user);
    if (user) {
      config.headers.token = `${user.token}`;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 400: {
          vue.$notify({
            showClose: true,
            message: error.response.data.message,
            type: 'error'
          });
          return Promise.reject(error);
        }
        case 401: {
          vue.$notify({
            showClose: true,
            message: error.response.data.message,
            type: 'error'
          });
          window.location.href = 'http://' + window.location.host + '/#/login';
          return Promise.reject(error);
        }
        case 403: {
          vue.$notify({
            showClose: true,
            message: error.response.data.message,
            type: 'error'
          });
          return Promise.reject(error);
        }
        case 422: {
          // var message = error.response.data.message
          let message = '';
          if ((typeof error.response.data.message === 'string') && error.response.data.message.constructor === String) {
            message = error.response.data.message
          } else {
            let keys = [];
            for (let key in error.response.data.message) {
              if (error.response.data.message.hasOwnProperty(key)) {
                keys.push(key)
              }
            }
            message = error.response.data.message[keys[0]][0];
          }

          vue.$notify({
            showClose: true,
            message: message,
            type: 'error'
          });
          return Promise.reject(error);
        }
        case 500: {
          vue.$notify({
            showClose: true,
            message: '网络错误',
            type: 'error'
          });
          return Promise.reject(error);
        }
      }
    }
    vue.$notify({
      showClose: true,
      message: '网络错误',
      type: 'error'
    });
    return Promise.reject(error);
  });

// config
export const getConfigSystemType = params => {
  return axios.get(`config/systemType`, {params});
};

// 个人信息
export const getProfileShow = params => {
  return axios.get(`system/profile`, {params});
};

export const postProfileUpdateInfo = params => {
  return axios.post(`system/profile/updateInfo`, params);
};

export const postProfileUpdatePassword = params => {
  return axios.post(`system/profile/updatePassword`, params);
};

// 反馈类别管理
export const postCategoryStore = params => {
  return axios.post(`system/category/store`, params);
};

export const deleteCategoryById = params => {
  return axios.delete(`system/category/delete/${params.id}`);
};

export const postCategoryUpdate = params => {
  return axios.post(`system/category/update`, params);
};

// 手机反馈
// 工厂列表
export const getComponentsFactorySelect = params => {
  return axios.get(`wap/componentsFactory/select?lang=${i18n.locale}`, {params});
};

export const getConfigFeedbackCode = params => {
  return axios.get(`config/feedbackCode?lang=${i18n.locale}`, {params});
};

// 分类列表
export const getCategory = params => {
  return axios.get(`wap/category?lang=${i18n.locale}`, {params});
};

// 图片上传
export const postUploadFeedbackImage = params => {
  return axios.post(`wap/attachment/uploadFeedbackImage?lang=${i18n.locale}`, params);
};

// 图片删除
export const postDeleteFeedbackImage = params => {
  return axios.post(`wap/attachment/delete?lang=${i18n.locale}`, params);
};

// 提交
export const postFeedbackStore = params => {
  return axios.post(`wap/feedback/store?lang=${i18n.locale}`, params);
};

// 配置文件
export const getConfigFeedbackType = params => {
  return axios.get(`config/feedbackType?lang=${i18n.locale}`, {params});
};

// 供应商列表
export const getFabricSupplierSelectList = params => {
  return axios.get(`wap/fabricSupplier/select?lang=${i18n.locale}`, {params});
};

export default {
  // 登入
  postLogin(params) {
    return axios.post(`system/login`, params);
  },
  // 上传头像
  profileUploadHeadImage(params) {
    return axios.post(`system/profile/uploadHeadImage`, params);
  },
  // 组织架构列表
  getOrganization(params) {
    return axios.get('system/v2/organization', {params});
  },

  //  保存组织架构
  addOrganization(params) {
    return axios.post('system/v2/organization/add', params);
  },
  //  编辑组织架构
  editOrganization(params) {
    return axios.post('system/v2/organization/edit', params);
  },
  // 无登录验证组织架构列表
  getOrganizationSelect(params) {
    return axios.get('system/v2/organization/select', {params});
  },
  //  删除组织架构
  deleteOrganization(params) {
    return axios.delete(`system/v2/organization/delete/${params.id}`, {});
  },
  // Process 列表
  getProcessList(params) {
    return axios.get('system/v2/process', {params});
  },
  // Process 新增
  addProcess(params) {
    return axios.post('system/v2/process/add', params);
  },
  // Process 编辑
  editProcess(params) {
    return axios.post('system/v2/process/edit', params);
  },
  //  删除组织架构
  deleteProcess(params) {
    return axios.delete(`system/v2/process/delete/${params.id}`, {});
  },
  // 获取汇率信息
  getSystemSettingInfo(params) {
    return axios.get(`system/v2/systemSetting/info/${params.type}`)
  },
  // 保存汇率信息
  saveSystemSetting(params) {
    return axios.post('system/v2/systemSetting/save', params);
  },
  // LeaderTime图表接口
  feedbackLeadTime(params) {
    return axios.get('system/feedback/leadTime', {params});
  },
  // 搜索用Process列表
  selectByTypeProcess(params) {
    return axios.get(`system/v2/process/selectByType/${params.type}`);
  },
  //monthlyShipmentQty 列表
  getMonthlyShipmentQtyList(params) {
    return axios.get('system/v2/monthlyShipmentQty', {params});
  },

  // 添加monthlyShipmentQty
  addMonthlyShipmentQty(params) {
    return axios.post('system/v2/monthlyShipmentQty/add', params);
  },

  // 批量保存 monthlyShipmentQty
  saveMonthlyShipmentQty(params) {
    return axios.post('system/v2/monthlyShipmentQty/save', params);
  },

  // 删除 monthlyShipmentQty
  deleteMonthlyShipmentQty(params) {
    return axios.delete('system/v2/monthlyShipmentQty/delete', {params});
  },

  // 获取Supplier 列表
  getSupplierList(params) {
    return axios.get('system/v2/supplier', {params});
  },

  // 保存Supplier
  addSupplier(params) {
    return axios.post('system/v2/supplier/add', params);
  },

  // 编辑 Supplier
  editSupplier(params) {
    return axios.post(`system/v2/supplier/edit`, params);
  },

  // 删除 Supplier
  deleteSupplier(params) {
    return axios.delete(`system/v2/supplier/delete`, {params});
  },

  // 根据Code获取Supplier
  selectByCodeSupplier(params) {
    let str = '';
    str = params.type ? '/' + params.type : '';
    str = params.code ? str + '/' + params.code : str;
    return axios.get(`system/v2/supplier/selectByCode${str}`, {params});
  },

  // 搜索框 Supplier 列表
  selectByTypeSupplier(params) {
    let str = '';
    str = params.type ? '/' + params.type : '';
    return axios.get(`system/v2/supplier/selectByType${str}`, {params});
  },

  // 获取 QPL 列表
  getQplList(params) {
    return axios.get('system/v2/qpl', {params});
  },

  // 获取搜索QPL列表
  selectQPLListByRole(params) {
    return axios.get(`system/v2/qpl/selectByRole/${params.role}`, {params})
  },

  // qpl 下属的supplier列表
  getSupplierListByQpl(params) {
    return axios.get(`system/v2/qpl/supplierList/${params.id}`)
  },

  // 删除QPL
  deleteQPL(params) {
    return axios.delete('system/v2/qpl/delete', {params})
  },

  // 激活QPL
  setActive(params) {
    return axios.post('system/v2/qpl/setActive', params);
  },

  // 编辑 QPL
  editQPL(params) {
    return axios.post('system/v2/qpl/edit', params);
  },

  // 保存 QPL
  addQPL(params) {
    return axios.post('system/v2/qpl/add', params);
  },

  // PTM 列表
  getPtmList(params) {
    return axios.get('system/v2/ptm', {params});
  },

  // 保存 PTM
  addPtm(params) {
    return axios.post('system/v2/ptm/add', params);
  },

  // 编辑 PTM
  editPTM(params) {
    return axios.post('system/v2/ptm/edit', params);
  },

  // 删除 PTM
  deletePTM(params) {
    return axios.delete('system/v2/ptm/delete', {params})
  },

  // PTM 详情
  showPTM(params) {
    return axios.get('system/v2/ptm/show/' + params);
  },

  // 注册发送注册验证码
  sendRegisterPlCode(params) {
    return axios.post('system/sendRegisterPlCode', params);
  },

  // 注册
  registerQPl(params) {
    return axios.post('system/registerPl', params);
  },
  // 找回密码发送注册验证码
  sendResetPasswordCode(params) {
    return axios.post('system/sendResetPasswordCode', params);
  },

  // 重置密码
  resetPassword(patams) {
    return axios.post('system/resetPassword', patams);
  },

  // 图表数据
  getFeedbackStatisticalData(params) {
    return axios.get(`system/feedback/statisticalData`, {params});
  },

  // 激活发送注册验证码
  sendActivateCode(params) {
    return axios.post('system/sendActivateCode', params);
  },

  // 激活
  activate(params) {
    return axios.post('system/activate', params);
  },

  getCategotyList(params) {
    return axios.get(`system/category`, {params});
  },

  getFeedbackList(params) {
    return axios.get(`system/feedback`, {params});
  },

  getFeedbackShowByID(params) {
    return axios.get(`system/feedback/show/${params.id}`);
  },

  // 上传
  postFeedbackSaveNewField(params) {
    return axios.post(`system/feedback/saveNewField`, params);
  },

  // 待状态关闭反馈
  postFeedbackClosedNew(params) {
    return axios.post(`system/feedback/closedNew`, params);
  },

  // 删除Case
  postFeedbackDelete(params) {
    return axios.post(`system/feedback/delete`, params);
  },

  // 根据供应商获取QPL
  getSupplierQpl(params) {
    return axios.get(`wap/supplier/getSupplierQpl/${params.id}`)
  },

  // 设为Pending状态
  feedbackPending(params) {
    return axios.post('system/v2/feedback/pending', params);
  },
  //  获取用户的订阅情况
  getUserSubscribeEmail(params) {
    return axios.get('system/v2/userSubscribeEmail/getUserData', params);
  },

  // 保存用户的订阅情况
  saveUserSubscribeEmail(params) {
    return axios.post('system/v2/userSubscribeEmail/save', params);
  },

  // 下载使用手册
  configDocUrl(params) {
    return axios.get('config/docUrl', {params});
  },

  // 根据Supplier获取Process
  getSupplierProcess(params) {
    return axios.get(`system/v2/supplier/getSupplierProcess/${params.id}`)
  },

  // 保存Supplier 的Process QPL
  setSupplierProcess(params) {
    return axios.post('system/v2/supplier/setSupplierProcess', params);
  },

  // 根据 Process 获取 Supplier
  getSupplierByProcess(params) {
    return axios.get(`system/v2/supplier/selectByProcess/${params.id}`);
  },

  // 获取 Process 与 supplier 树状数据
  selectAttachSupplier(params) {
    return axios.get('system/v2/process/selectAttachSupplier', {params});
  },

  //  lead time supplier 柱状图
  feedbackLeadTimeWithSupplier(params) {
    return axios.get('system/feedback/leadTimeWithSupplier', {params});
  },

  // QPL Supplier 解除绑定
  supplierUnbind(params) {
    return axios.post('system/v2/supplier/unbind', params);
  },

  //  PTM绑定QPL
  ptmBindQpl(params) {
    return axios.post('system/v2/qpl/ptmBindQpl', params);
  },

  //  PTM绑定QPL
  ptmRemoveQpl(params) {
    return axios.post('system/v2/qpl/ptmRemoveQpl', params);
  },

  // 问卷调查列表
  getAllQuestionnaires(params) {
    return axios.get('system/v2/questionnaire/getAllQuestionnaires', params);
  },

  // 获取到调查列表
  getQuestInfo(params) {
    return axios.get('system/v2/questionnaire/getQuestInfo/' + params.token);
  },

  // 提交问卷
  submitQuest(params) {
    return axios.post('system/v2/questionnaire/submitQuest', params);
  },

  //  获取问卷回答报告
  getStatisticsData(params) {
    return axios.get('system/v2/questionnaire/getStatisticsData', {params});
  },

  //  申请样品
  sampleRequest(params) {
    return axios.post('system/v2/sampleRequest/request', params);
  },

  // 填写快递单号
  setCourierNumber(params) {
    return axios.post('system/v2/sampleRequest/setCourierNumber', params);
  },

  // Not Responsibility Reason 原因
  getNotResponsibilityReason(params) {
    return axios.get('config/getNotResponsibilityReason', {params});
  },

  // 获取数量的
  getIsUrgent(params) {
    return axios.get('system/v2/feedback/getIsUrgent', {params});
  },

  // Quality Follow Up Chart1
  qualityFollowUp(params) {
    return axios.get('system/v2/chart202206/quality-follow-up', {params});
  },

  // Claim Type Chart（客诉分类）
  claimType(params) {
    return axios.get('system/v2/chart202206/claim-type', {params});
  },

  // Lead Time（客诉处理时效）
  leadTime(params) {
    return axios.get('system/v2/chart202206/lead-time', {params});
  },

  // Non-reliability claim（成衣无效投诉数量）
  nonReliabilityClaim(params) {
    return axios.get('system/v2/chart202206/non-reliability-claim', {params});
  },

  // Monthly RPM
  monthlyRpm(params) {
    return axios.get('system/v2/chart202206/monthly-rpm', {params});
  },
  // YTD RPM
  ytdRpm(params) {
    return axios.get('system/v2/chart202206/ytd-rpm', {params});
  },
  // Monthly NQC和YTD NQC
  nqc(params) {
    return axios.get('system/v2/chart202206/nqc', {params});
  },

  // 分类详细列表
  claimList(params) {
    return axios.get('system/v2/chart202206/claim-list', {params});
  },

  // Re-occurred problem analysis（中文：重复发生问题分析）组转图
  repeatTotal(params) {
    return axios.get('system/v2/chart202206/repeat-total', {params});
  },

  // Re-occurred problem analysis（中文：重复发生问题分析）点阵图
  repeatSpot(params) {
    return axios.get('system/v2/chart202206/repeat-spot', {params});
  },

  // 是否可以修改某些字段
  feedbackCanUpdateField(params) {
    return axios.get('system/v2/feedback/can-update-field', {params});
  },

  // 修改return quantity 和nqc
  feedbackUpdateFinalField(params) {
    return axios.post('system/v2/feedback/update-final-field', params);
  },

  // 本系统获取订单数据
  cspGetDataByPo(params) {
    return axios.get('wap/csp/get-data-by-po', {params});
  },

  // 供应商评级-报表
  cptSupplierEvaluationChart(params) {
    return axios.get('system/v2/cap202209/cpt-supplier-evaluation-chart', {params});
  },

  // 供应商评级-top 10
  top10DefectsItems(params) {
    return axios.get('system/v2/cap202209/top10-defects-items', {params});
  },

//  供应商评级-下方详情
  cptSupplierEvaluationList(params) {
    return axios.get('system/v2/cap202209/cpt-supplier-evaluation-list', {params});
  },

  // 供应商评级-审核
  capValidate(params) {
    return axios.post('system/v2/cap202209/cap-validate', params);

  }
}



// WEBPACK FOOTER //
// ./src/api/api.js